// import { Loc } from 'main.core';
import { UserSpecificNoticeBase } from 'b24network.vue.invite-shared';
import { UserAccount } from 'b24network.vue.cross-scenario-shared-js';

/**
 * User haven't confirmed an email for his account
 */
export class UserEmailNotConfirmed extends UserSpecificNoticeBase
{
	constructor(account: UserAccount)
	{
		super(
			'',
			account,
		);
	}
}
